// CCalendar is imported here to vite be able to detect its sub-dependencies
import '@convenia/components/CCalendar'

import Maska from 'maska'
import showModal from '@convenia/components/directives/modules/showModal'
import { dayjsPluginVue3 } from '@convenia/utils/modules/dayjs'

export default (app) => {
  app.use(Maska)
  app.use(dayjsPluginVue3)
  app.directive('showModal', showModal)

  app.config.globalProperties.$css = {
    get (varName, target) {
      return getComputedStyle(target || document.documentElement).getPropertyValue(varName)
    },
    set (varName, val, target) {
      const el = target || document.documentElement
      el.style.setProperty(varName, val)
    }
  }
}
